module.exports = __webpack_public_path__ + "static/media/twitter-brands-solid.3ae4619b.svg";